import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PlanTable from '../components/PlanTable';

const PlansPage = () => {
  let navigate = useNavigate();
  return (
    <Box p={2}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <h1>Plans</h1>
        <Button variant="contained" color="primary" onClick={() => navigate('/plans/create')}>
          Create Plan
        </Button>
      </Box>
      <PlanTable />
    </Box>
  );
};

export default PlansPage;
